import styled from "styled-components";
import { Button, Theme } from "@screencloud/screencloud-ui-components";
import { StyledContainer } from "../styles";
import bg from "../images/bg.png";

export const Styled = styled(StyledContainer)`
  background: url(${bg}) no-repeat;
  background-size: cover;
  color: var(--Shades-White, #fff);

  @media screen and (max-width: ${Theme.break.small}) {
    justify-content: flex-start;
    padding-left: 16px;
  }
`;

export const StyledButton = styled(Button)<{ isTrialEnd?: boolean }>`
  &.button {
    * {
      font-family: Sora;
    }

    border-radius: 40px;
    background: var(--Shades-Main-Text, #19191b);
    border: none;
    box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.1);
    padding: 11px 20px;

    color: var(--Shades-White, #fff);
    font-size: var(--font-size-sm, 14px);
    font-weight: 400;

    &:hover {
      background: var(--Shades-Body-Text, #474749);
      color: var(--Shades-White, #fff);
      border: none;
    }
  }
`;

export const StyledContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: ${Theme.break.small}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const StyledMessageContainer = styled.span`
  font-family: Sora;
  font-size: var(--font-size-md, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--font-line-height-md, 24px); /* 150% */

  strong {
    font-family: Sora;
  }

  @media screen and (max-width: ${Theme.break.small}) {
    font-size: var(--font-size-sm, 14px);
  }
`;
